<script setup lang="ts">
import type {
  BoardMenu,
  NovaBoxBoardSideMenuProps,
} from './NovaBoxBoardSideMenu.types'

defineProps<NovaBoxBoardSideMenuProps>()

const { t, locale, messages } = useI18n()
const { gtEvent } = useGoogleTag()

const router = useRouter()
const route = useRoute()
const menus = computed<BoardMenu[]>(() =>
  Object.keys((messages.value[locale.value].board as any).title)
    .filter((key) => key !== 'terms')
    .map((key) => ({
      path: key,
      label: t(`board.title.${key}`),
    }))
)
const on = ref(false)

// 게시판 이동
const onClickLink = (path: string) => {
  if (route.path !== `/board/${path}`) {
    gtEvent('clickEvent', {
      eventCategory: '클릭',
      eventAction: `게시판 > ${path} 이동`,
      eventLabel: path,
      eventSlot: '게시판 사이드 메뉴',
      eventI18nAddr: path,
      eventComponent: 'List',
    })
  }
  router.push({
    path:
      locale.value === 'ko'
        ? `/board/${path}`
        : `/${locale.value}/board/${path}`,
  })
}
</script>

<template>
  <aside class="menu-area">
    <div class="menu-header">
      <span class="title">{{ $t('board.sideTitle') }}</span>
      <span :class="['icon-button', { on }]">
        <NovaButtonIcon
          :icon="{ type: 'outline', name: 'carrot-bottom' }"
          :size="20"
          :class="['btn-open']"
          @click="on = !on"
        />
      </span>
    </div>

    <ul :class="['menu-list', { on }]">
      <li
        v-for="(item, index) in menus"
        :key="index"
        :class="item.path === active ? 'on' : ''"
        @click="onClickLink(item.path)"
      >
        {{ item.label }}
      </li>
    </ul>
  </aside>
</template>

<style lang="scss" scoped>
.menu-area {
  flex-shrink: 0;
  padding: 20px;
  max-width: 190px;
  width: 100%;
  background-color: $color-white;
  border-radius: $radius-10;
  .title {
    @include text-style($text-heading3-bold);
  }
  .icon-button {
    display: none;
  }

  .menu-list {
    display: block;
    margin-top: 10px;

    li {
      padding: 10px;
      @include text-style($text-body-14-regular);
      color: $color-text-2;
      border-radius: 6px;
      cursor: pointer;
    }
    li.on {
      background-color: $color-bg-1;
    }
  }
}

@include mobile {
  .menu-area {
    max-width: none;

    .menu-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .icon-button {
      display: block;
      width: 20px;
      height: 20px;
      color: $color-text-3;

      @include transition(transform 0.2s);

      &.on {
        transform: rotate(180deg);
      }
    }

    .menu-list {
      display: none;
    }

    .menu-list.on {
      display: block;
    }
  }
}
</style>
